// Addresses for development and staging environments
const TREASURY_ADDRESS_DEV = '0xa1299aD63e9A4e7c1eBeE4ccce64c6b1051356fF'

// Addresses only for prod environment
const TREASURY_ADDRESS_PROD = '0x64ddaa09ea57d334600dd779f8edd750ca68c7e4'

export const TREASURY_ADDRESS = TREASURY_ADDRESS_DEV
